import { Component, inject, Inject } from '@angular/core';
import type { AbstractControl, ValidationErrors } from '@angular/forms';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import type { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { DialogComponent } from '@shared/dialogs/dialog.component';
import type { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { CurrentUser } from '@shared/services/current-user/current-user.service';

@Component({
    selector: 'app-danger-confirm-dialog',
    templateUrl: './danger-confirm-dialog.component.html',
    styleUrls: ['./danger-confirm-dialog.component.scss']
})
export class DangerConfirmDialogComponent extends DialogComponent {
    protected readonly currentUser = inject(CurrentUser);

    protected readonly form = new FormGroup({
        confirm: new FormControl<string>(null, [Validators.required, this.equalsValidator(this.data.valueMatch)]),
        password: new FormControl<string>(null, [this.data.requirePassword ? Validators.required : null]),
    });

    public submitting = false;

    constructor(
        public dialogRef: MatDialogRef<DangerConfirmDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DangerConfirmDialogData
    ) {
        super();

        if (!this.currentUser.supportsPasswordPrompts()) {
            this.form.controls.password.disable();
        }
    }

    public request = () => {
        this.submitting = true;

        this.data.confirmRequest(this.form.value.password).pipe(
            finalize(() => this.submitting = false)
        ).subscribe(response => {
            if (response) {
                this.dialogRef.close();
            }
        });
    };

    private equalsValidator(mustEqual: string): (control: AbstractControl) => ValidationErrors | null {
        return (control) => control.value?.toLowerCase() === mustEqual.toLowerCase() ? null : { equals: false };
    }

    public static show(dialog: MatDialog, data: DangerConfirmDialogData) {
        return dialog.open<DangerConfirmDialogComponent, DangerConfirmDialogData, boolean>(DangerConfirmDialogComponent, {
            data,
            minWidth: '320px',
            maxWidth: 480
        });
    }
}

export interface DangerConfirmDialogData {
    title: string;
    contentHtml: string;
    valueMatch: string;
    confirmRequest: (password?: string) => Observable<any>;
    confirmInputLabel?: string;
    requirePassword?: boolean;
    okay?: string;
    confirmText?: string;
}
